import React, { useState } from 'react';
import { motion } from 'framer-motion';
import ImageModal from '../common/ImageViewer';
import { IMAGES } from '../../data/images';

const images = IMAGES.carousel.map((src, index) => ({
  src,
  alt: `Image ${index + 1}`
}));

export default function ImageCarousel() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  
  const handleImageClick = (image) => {
    setSelectedImage(image);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
  };
  
  return (
    <div className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden">
          {/* Gradient overlays for smooth edges */}
          <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-white to-transparent z-10" />
          <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-white to-transparent z-10" />
          
          {/* Scrolling container */}
          <motion.div
            className="flex gap-4 py-4"
            animate={{
              x: [0, -1920],
            }}
            transition={{
              x: {
                repeat: Infinity,
                repeatType: "loop",
                duration: 30,
                ease: "linear",
              },
            }}
          >
            {/* Double the images for seamless loop */}
            {[...images, ...images].map((image, index) => (
              <motion.div
                key={`${image.alt}-${index}`}
                className="flex-shrink-0 relative group cursor-pointer"
                whileHover={{ scale: 1.05 }}
                onClick={() => handleImageClick(image)}
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-64 h-40 object-cover rounded-lg shadow-md"
                />
                <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity rounded-lg" />
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>

      {/* Image Modal */}
      <ImageModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        imageUrl={selectedImage?.src}
        alt={selectedImage?.alt}
      />
    </div>
  );
}